import Dialog from "@material-ui/core/Dialog";
import React from "react";
import {useOnEnter} from "../hooks/DialogHooks";

export const FullImagePreview = ({src, onClick}) => {

    useOnEnter(onClick);

    return (
        <Dialog maxWidth={"lg"} open={true} onEscapeKeyDown={onClick}>
            <div>
                <a onClick={onClick}>
                    <img src={src} />
                </a>
            </div>
      </Dialog>
    )
}